import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import cn from './PaymentPlanCardPlaceholder.module.scss';

export class PaymentPlanCardPlaceholder extends React.PureComponent {
  render() {
    const { onPaymentPlanAdd } = this.props;

    return (
      <Card className={cn.card}>
        <CardContent className={cn.content}>
          <IconButton onClick={onPaymentPlanAdd}>
            <AddIcon fontSize="large" />
          </IconButton>
        </CardContent>
      </Card>
    );
  }
}

